module.exports = __webpack_public_path__ + "static/media/EdSider_Quick Guide (Paper Search)_062024_V2 1.a33ff259.pdf";